<unclaimed-message [task]="task" (claimed)="getTask()"></unclaimed-message>
@if (task?.purchaseRequisition) {
    <purchase-requisition-detail
        [purchaseRequisition]="task.purchaseRequisition"
        [supplierChangeAllowed]="task.supplierChangeAllowed"
        [editingWithDialog]="true"
        [task]="task"
        #purchaseRequisitionDetailComponent
    >
        <div class="row justify-content-end mb-2">
            <div class="col-auto">
                <task-hint-display [hint]="task.hint"></task-hint-display>
            </div>
        </div>
        <div class="row justify-content-end mb-2" *removeIfUnclaimed="task">
            @if (task.purchaseRequisition.demand.hasIncotermDeviation) {
                <div class="col-12 mb-2">
                    <div class="alert alert-warning mb-0" role="alert">
                        <em class="fas fa-exclamation-triangle pe-2"></em>
                        {{
                            'Der gewählte Incoterm weicht vom Standard-Incoterm eines Lieferanten ab. Sie können die Bedarfsmeldung dennoch freigeben.'
                                | translate
                        }}
                    </div>
                </div>
            }
            @if (showDemandInvalidHint) {
                <!-- EPROC-11425 reopen #5b (238308): generic on purpose — the concrete reason (missing
                     field, pending currency check) is shown at its place inside the embedded demand. -->
                <div class="col-12 mb-2">
                    <div class="alert alert-warning mb-0" data-cy="PURCHASE_REQUISITION_INVALID_HINT">
                        <em class="fas fa-circle-info pe-1"></em>
                        {{
                            'Die Freigabe ist noch nicht möglich: Die Bedarfsmeldung erfüllt noch nicht alle Voraussetzungen. Prüfen Sie die Hinweise und Pflichtfelder in der Bedarfsmeldung.'
                                | translate
                        }}
                    </div>
                </div>
            }
            <div class="col-auto">
                <div class="btn-group">
                    <button
                        class="btn btn-warning"
                        [disabled]="!purchaseRequisitionDetailComponent.isValid"
                        (click)="decide(false)"
                    >
                        <em class="fas fa-ban pe-2"></em>
                        {{ 'ablehnen' | translate }}
                    </button>
                    <button class="btn btn-success" [disabled]="approvalBlocked" (click)="decide(true)">
                        <em class="fas fa-check pe-2"></em>
                        {{ 'freigeben' | translate }}
                    </button>
                </div>
            </div>
        </div>
        <div class="row justify-content-end mb-2" *showIfUnclaimed="task">
            <claim-btn [task]="task" (claimed)="getTask()"></claim-btn>
        </div>
    </purchase-requisition-detail>
}
